export default {
  name: 'marking--outH',
  apiService: 'shoes',
  apiPath: '/admin/out_h',
};
